import { React } from 'react';
import sampleLogo from '../Assets/Images/HHG_Final_Logo_2.png'
import { Link } from "react-router-dom";
import Home from '../Views/Home';
import { color } from 'three/tsl';

const Footer = () => {
    return(
        <footer itemscope="itemscope" itemtype="https://schema.org/WPFooter">
	        <div data-elementor-type="page" data-elementor-id="1046" class="elementor elementor-1046">
				<div class="elementor-element elementor-element-763a292 e-flex e-con-boxed e-con e-parent" data-id="763a292" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
		<div class="elementor-element elementor-element-cfba508 e-con-full e-flex e-con e-child" data-id="cfba508" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		<div class="custom-logo elementor-element elementor-element-71d6839 e-con-full e-flex e-con e-child" data-id="71d6839" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-d093d54 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="d093d54" data-element_type="widget" data-widget_type="image.default">
				<div className="elementor-widget-container">
    <Link to="/">
        <img 
            fetchpriority="high" 
            width="481" 
            height="133" 
            src={sampleLogo} 
            className="attachment-large size-large wp-image-1666" 
            alt="Home Logo" 
            decoding="async" 
            sizes="(max-width: 481px) 100vw, 481px" 
            style={{ paddingTop: "11px", cursor: "pointer" }} 
        />
    </Link>
</div>
				</div>
				<div class="elementor-element elementor-element-1fbd715 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor" data-id="1fbd715" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							This insightful exploration delves into the latest advances in robotic technologies, artificial intelligence, and automation.						</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-57af291 e-con-full e-flex e-con e-child" data-id="57af291" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-3003d0f elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="3003d0f" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h4 class="elementor-heading-title elementor-size-default">Quick Links</h4>		</div>
				</div>
				<div class="elementor-element elementor-element-dd63177 elementor-widget__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="dd63177" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
				<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<a href="/">

											<span class="elementor-icon-list-text">Home</span>
											</a>
									</li>
								{/* <li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li> */}
								{/* <li class="elementor-icon-list-item">
											<a href="/about">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li> */}
								{/* <li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Team</span>
											</a>
									</li> */}
									{/* <li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Prototyping</span>
											</a>
									</li> */}
								<li class="elementor-icon-list-item">
											<a href="Products">

											<span class="elementor-icon-list-text">Products</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="about">

											<span class="elementor-icon-list-text">About</span>
											</a>
									</li>
									
									<li class="elementor-icon-list-item">
											<a href="ContactUs">

											<span class="elementor-icon-list-text">Contact</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="Career">

											<span class="elementor-icon-list-text">Career</span>
											</a>
									</li>

						</ul>
				</div>
				</div>
				</div>
				<div class="elementor-element elementor-element-57af291 e-con-full e-flex e-con e-child" data-id="57af291" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-3003d0f elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="3003d0f" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			{/* <h4 class="elementor-heading-title elementor-size-default">Services</h4>		 */}
			</div>
				</div>
				<div class="elementor-element elementor-element-dd63177 elementor-widget__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="dd63177" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
				{/* <ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<a href="/robotic">

											<span class="elementor-icon-list-text">Robotic Solutions</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="/about">

											<span class="elementor-icon-list-text">Services</span>
											</a>
									</li>
								<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Team</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Prototyping</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="#">

											<span class="elementor-icon-list-text">Design & Consultation</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/printing">

											<span class="elementor-icon-list-text">3D Printing</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/scanning">

											<span class="elementor-icon-list-text">3D Scanning</span>
											</a>
									</li>
									<li class="elementor-icon-list-item">
											<a href="/Career">

											<span class="elementor-icon-list-text">Career</span>
											</a>
									</li>
						</ul> */}
				</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-bf9662a e-con-full e-flex e-con e-child" data-id="bf9662a" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-dc46677 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="dc46677" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h4 class="elementor-heading-title elementor-size-default">Contact Info</h4>		</div>
				</div>
				{/* <div class="elementor-element elementor-element-c848495 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="c848495" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_29_676b79794d8d1" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-"><div class="icon style-color"><i aria-hidden="true" class="fas fa-envelope"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Email</h6><p class="icon-box-description">inquiry@hhgindia.com</p>
            </div>
            
            </div></div>		</div>
				</div> */}
				<div class="elementor-element elementor-element-c848495 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="c848495" data-element_type="widget" data-widget_type="jkit_icon_box.default">
    <div class="elementor-widget-container">
        <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_29_676b79794d8d1">
            <div class="jkit-icon-box-wrapper hover-from-left">
                <div class="icon-box icon-box-header elementor-animation-">
                    <div class="icon style-color">
                        <i aria-hidden="true" class="fas fa-envelope"></i>
                    </div>
                </div>
                <div class="icon-box icon-box-body">
                    <h6 class="title">Email</h6>
                    <p class="icon-box-description">
					<a href="mailto:inquiry@hhgindia.com" style={{ color: '#605c5c' }}>inquiry@hhgindia.com</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

				<div class="elementor-element elementor-element-3073f44 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="3073f44" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_30_676b79794e8b5" >
				<div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-">
					<div class="icon style-color"><i aria-hidden="true" class="fas fa-phone-alt"></i></div></div>
					<div class="icon-box icon-box-body">
                <h6 class="title">Contact for Queries</h6><p class="icon-box-description">+91 97260 55997</p>
				
            </div>
           
            </div>
			
			
			</div>		
			
			
			</div>
			
				</div>
				<div class="elementor-element elementor-element-3073f44 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="3073f44" data-element_type="widget" data-widget_type="jkit_icon_box.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation- jeg_module_6_30_676b79794e8b5" >
				<div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-">
					<div class="icon style-color"><i aria-hidden="true" class="fas fa-phone-alt"></i></div></div>
					<div class="icon-box icon-box-body">
			<h6 class="title">Contact for Career </h6><p class="icon-box-description">+91 70699 90856</p>
				
            </div>
           
            </div>
			
			
			</div>		
			
			
			</div>
			
				</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-7ec5110 e-con-full e-flex e-con e-child" data-id="7ec5110" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		<div class="elementor-element elementor-element-4e79600 e-con-full e-flex e-con e-child" data-id="4e79600" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-a883e73 elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget__width-initial elementor-widget elementor-widget-heading" data-id="a883e73" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h3 class="elementor-heading-title elementor-size-default">Subscribe Our Newsletter!</h3>		</div>
				</div>
				<div class="elementor-element elementor-element-490d3d5 elementor-widget-mobile__width-inherit elementor-widget elementor-widget-jkit_mailchimp" data-id="490d3d5" data-element_type="widget" data-widget_type="jkit_mailchimp.default">
				<div class="elementor-widget-container">
			<div  class="jeg-elementor-kit jkit-mailchimp style-inline jeg_module_6_31_676b797951400" ><form method="post" class="jkit-mailchimp-form" data-listed="" data-success-message="Successfully listed this email" data-error-message="Something went wrong">
            <div class="jkit-mailchimp-message"></div>
            <div class="jkit-form-wrapper email-form">
                <div class="jkit-mailchimp-email jkit-input-wrapper input-container">
            <div class="jkit-form-group">
                <div class="jkit-input-element-container jkit-input-group">
                    <input type="email" name="email" class="jkit-email jkit-form-control " placeholder="Your Email Address" required="" />
                </div>
            </div>
        </div><div class="jkit-submit-input-holder jkit-input-wrapper">
            <button type="submit" class="jkit-mailchimp-submit position-after" name="jkit-mailchimp">
                Subscribe Now
            </button>
        </div>
            </div>
        </form></div>		</div>
				</div>
				</div>
		<div class="elementor-element elementor-element-9d91a4f e-con-full e-flex e-con e-child" data-id="9d91a4f" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				<div class="elementor-element elementor-element-180ff39 e-grid-align-right e-grid-align-tablet-left e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 elementor-widget elementor-widget-social-icons" data-id="180ff39" data-element_type="widget" data-widget_type="social-icons.default">
				<div class="elementor-widget-container">
					{/* <div class="elementor-social-icons-wrapper elementor-grid">
							<span class="elementor-grid-item">
					<a class="elementor-icon elementor-social-icon elementor-social-icon-jki-facebook-light elementor-repeater-item-7891042" target="_blank">
						<span class="elementor-screen-only">Jki-facebook-light</span>
						<i class="jki jki-facebook-light"></i>					</a>
				</span>
							<span class="elementor-grid-item">
					<a class="elementor-icon elementor-social-icon elementor-social-icon-twitter elementor-repeater-item-99abf06" target="_blank">
						<span class="elementor-screen-only">Twitter</span>
						<i class="fab fa-twitter"></i>					</a>
				</span>
							<span class="elementor-grid-item">
					<a class="elementor-icon elementor-social-icon elementor-social-icon-youtube elementor-repeater-item-7dc9a73" target="_blank">
						<span class="elementor-screen-only">Youtube</span>
						<i class="fab fa-youtube"></i>					</a>
				</span>
							<span class="elementor-grid-item">
					<a class="elementor-icon elementor-social-icon elementor-social-icon-jki-whatsapp-1-light elementor-repeater-item-cb0f8be" target="_blank">
						<span class="elementor-screen-only">Jki-whatsapp-1-light</span>
						<i class="jki jki-whatsapp-1-light"></i>					</a>
				</span>
					</div> */}
				</div>
				</div>
				</div>
				</div>
					</div>
				</div>
		<div class="elementor-element elementor-element-c7e9be9 e-flex e-con-boxed e-con e-parent" data-id="c7e9be9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
					<div class="e-con-inner">
				<div class="elementor-element elementor-element-363a7b0 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor" data-id="363a7b0" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							Copyright © 2024 HHG Industries Private Limited. All rights reserved.						</div>
				</div>
				<div class="elementor-element elementor-element-40138f6 elementor-icon-list--layout-inline elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="40138f6" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items elementor-inline-items">
							<li class="elementor-icon-list-item elementor-inline-item">
											<a href="#">

											<span class="elementor-icon-list-text">Terms & Conditions</span>
											</a>
									</li>
								<li class="elementor-icon-list-item elementor-inline-item">
											<a href="#">

											<span class="elementor-icon-list-text">Privacy Policy</span>
											</a>
									</li>
						</ul>
				</div>
				</div>
					</div>
				</div>
							</div>
						</footer>
    )
}

export default Footer;